import React from 'react'
import { com } from '@eidu/web'
import { Text } from '@common/ui'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EntityFieldDisplayRow from './EntityFieldDisplayRow'
import Field = com.eidu.entity.field.Field

export type EntityFormTextDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormTextDisplay = ({ field, fieldValue }: EntityFormTextDisplayProps) => (
  <EntityFieldDisplayRow field={field}>
    <Text size="sm">{fieldValue?.value ?? ''}</Text>
  </EntityFieldDisplayRow>
)

export default EntityFormTextDisplay
